// React stays imported for the classic JSX transform vitest uses when this
// component renders outside the Next.js build (`VerificationCodeInput.test.tsx`).
import React from "react";
import Input, { type InputProps } from "antd/es/input";

type VerificationCodeInputProps = Pick<
  InputProps,
  "id" | "size" | "placeholder" | "status" | "aria-label"
> & {
  value?: string;
  /** Receives the digits only: spaces and dashes in a pasted code are dropped. */
  onChange: (code: string) => void;
};

/**
 * The code field on every customer OTP step: booking (new and returning
 * customer), reschedule, and the manage page's cancel. One component so the
 * four cannot drift again (#739: the cancel field had lost the number pad).
 *
 * `autoComplete="one-time-code"` is what lets the phone offer the code from
 * the incoming SMS or email above the keyboard; Android Chrome's SMS autofill
 * needs it, and iOS Safari only guesses without it.
 */
export default function VerificationCodeInput({
  onChange,
  ...inputProps
}: VerificationCodeInputProps) {
  return (
    <Input
      {...inputProps}
      autoComplete="one-time-code"
      inputMode="numeric"
      maxLength={8}
      onChange={(event) => onChange(event.target.value.replace(/\D/g, ""))}
    />
  );
}
